/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
/* eslint-disable no-script-url */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { PureComponent, Fragment } from 'react';
import { Card, CardBody, Col, Label } from 'reactstrap';
import TableCell from '@material-ui/core/TableCell';
import QueryString from 'query-string';
import RUTJS from 'rutjs';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import jwtDecode from 'jwt-decode';
import { find, remove, map, filter, upperCase, some } from 'lodash';
import moment from 'moment';
import MatTable from '../../../shared/components/MaterialTable';
import {
  getUsers,
} from '../../../redux/actions/userActions';
import { setRUTFormat, isUserAllowed, getUserId } from '../../../shared/utils';
import {
  getAllQuotations,
  getAllQuotationsMe,
  updateQuotationMany,
  getConcessionaires,
  getExcelQuotations
} from '../../../redux/actions/quotationsActions';
import {
  getContactByRut,
  resetContact,
  getContacts,
} from '../../../redux/actions/contactosActions';
import BasicNotification from '../../../shared/components/Notifications/BasicNotification';
import ModalAC from './AssignQuotationsModal';
import FilterModal from '../../../shared/components/Modal/ModalQuotationsFilter';
import ModalReasingSharp from '../../../shared/components/Modal/ModalReasingSharp';
import DatePicker from "react-datepicker";
import Icon from '@mdi/react';
import { mdiClose, mdiFilterOutline, mdiFilterRemoveOutline, mdiMagnify } from '@mdi/js';
import { ADMIN_QUOTATION_ROLE_FILTER, FIRST_SECOND_CONTACT_FILTER, ROLES } from '../../../helper/constants';
import { originTraducer } from '../../../helper/functions';

class DefaultTabsBorderedBottom extends PureComponent {
  state = {
    activeTab: '1',
    isOpenModalAC: false,
    isOpenModalNC: false,
    isOpenModalFilter: false,
    origen: '',
    justAdminOrManager: false,
    purchaseAdvisor: false,
    firstExecutive: false,
    secondContact: false,
    headers: [],
    tipo: null,
    tipify: null,
    rut: '',
    description: '',
    selected: [],
    search: null,
    order: 'asc',
    orderBy: 'calories',
    isOpenModalReasing: false,
    reasign: true,
    reasignQuotations: [],
    reasignQuotationsOnwer: '',
    executives: {},
    executiveSelected: null,
    disabledIt: false,
    hideFind: false,
    page: 0,
    rowsPerPage: 10,
    hideNewContact: true,
    appointment: '',
    assign: '',
    isOpenModalD: false,
    client: '',
    firstName: '',
    lastName: '',
    usersFilters: null,
    typesFilters: null,
    subTypesFilters: null,
    codeFilters: null,
    contactsFilters: null,
    concessionaires: null,
    valueToFilter: {
      executive: null,
      origin: null,
      status: null,
      fromDate: null,
      toDate: null,
      inTrinidad: null,
      evaluationStatus: null,
      trinidadStatus: null,
      concessionaire: null
    },
    onlyNotClosed: true,
    filterStatus: true,
    checked: [],
    startDate: moment().startOf('month').toDate(),
    endDate: new Date(),
    dateError: undefined,
    contactSearchit: false
  };

  componentWillUnmount = () => {
    this.props.resetContact();
    this.setState({ contactSearchit: false });
  };

  componentDidMount() {

    const isAdmin = isUserAllowed('admin') || isUserAllowed('manager');
    const firstExecutive = isUserAllowed(ROLES.firstContactExecutive);
    const secondContact = isUserAllowed(ROLES.salesExecutiveSc)
    const purchaseAdvisor = isUserAllowed(ROLES.purchaseAdvisorSc);
    let { page = 1, limit = 10 } = QueryString.parse(this.props.location.search);
    const query = {};
    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }
    this.setState({ page, rowsPerPage: limit, justAdminOrManager: isAdmin, firstExecutive, purchaseAdvisor, secondContact });

    const {
      rut = false,
      onlyNotClosed = true,
      filterStatus = true,
      executive,
      origin,
      status,
      fromDate,
      toDate,
      inTrinidad,
      evaluationStatus,
      trinidadStatus,
    } = QueryString.parse(this.props.location.search);

    const token = localStorage.getItem('accessToken');
    if (token) {
      const { user } = jwtDecode(token);
      const reasignQuotationsOnwer = `${user.firstName} ${user.lastName}`;
      this.setState({ reasignQuotationsOnwer });
      let commonHeaders = [
        { id: 'code', disablePadding: true, label: 'ID', },
        { id: 'Origen', disablePadding: true, label: 'Origen', },
        { id: 'spider', disablePadding: true, label: 'Nombre CES', },
        { id: 'Estado', disablePadding: true, label: 'Estado CRM', },
        { id: 'trinidadState', disablePadding: true, label: 'Estado Cotización', },
        { id: 'Nombre cliente', disablePadding: false, label: 'Nombre cliente', },
        { id: 'Rut cliente', disablePadding: false, label: 'Rut cliente', },
        { id: 'createdAt', disablePadding: false, label: 'Fecha ingreso', },
      ]
      if (isAdmin || secondContact) {
        let addedHeders = [
          { id: 'offersStatus', disablePadding: false, label: 'Estado Oferta' },
          { id: 'offersCount', disablePadding: false, label: 'Ofertas' }
        ]
        commonHeaders.push(...addedHeders);
      }
      if (isAdmin || firstExecutive) {
        let addedHeders = [
          { id: 'Ejecutivo Asignado', disablePadding: false, label: 'Ejecutivo Asignado' }
        ]
        commonHeaders.push(...addedHeders);
      }
      if (isAdmin || purchaseAdvisor) {
        let addedHeders = [
          { id: 'offersRequest', disablePadding: false, label: 'Solicita Oferta', }
        ]
        commonHeaders.push(...addedHeders);
      }

      this.setState({ headers: commonHeaders });

      if (isAdmin || purchaseAdvisor) {
        if (isAdmin) {
          this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
            this.setState({
              executives: map(body, userExecutive => ({ value: userExecutive._id, label: `${userExecutive.firstName} ${userExecutive.lastName}`, sharp: userExecutive.sharpExist })),
              usersFilters: map(body, userF => ({ value: userF._id, label: `${userF.firstName} ${userF.lastName}` }))
            });
          });
        }
        this.props.getAllQuotations({ onlyNotClosed, executive, origin, status, fromDate, toDate, inTrinidad, evaluationStatus, trinidadStatus, requiresOffers: purchaseAdvisor });
      } else {
        if (firstExecutive) {
          this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
            this.setState({
              executives: map(body, userExecutive => ({ value: userExecutive._id, label: `${userExecutive.firstName} ${userExecutive.lastName}`, sharp: userExecutive.sharpExist })),
              usersFilters: map(body, userF => ({ value: userF._id, label: `${userF.firstName} ${userF.lastName}` }))
            });
          });
        }

        let myQuery = {
          onlyNotClosed,
          executive,
          origin,
          status,
          fromDate,
          toDate,
          inTrinidad,
          evaluationStatus,
          trinidadStatus
        }
        if (firstExecutive) {
          myQuery.filterStatus = filterStatus;
        }
        this.props.getAllQuotationsMe(myQuery);
      }

      this.props.getConcessionaires((res) => {
        const ces = map(res.body, ces => ({ value: `${ces.DeaCodigoDealer}`, label: `${ces.DeaNombre.substr(ces.DeaNombre.indexOf(' ') + 1)}` }));
        // console.log('concesionarios', ces);
        this.setState({ concessionaires: ces });
      });

      const {
        firstName,
        lastName,
      } = user;

      this.setState({
        firstName,
        lastName,
        isAdmin,
      });
    }

    if (rut) {
      this.setState({ rut, isOpenModalAC: true });
    }
  }

  onClickQuotationView = e => () => {
    this.props.history.push(`/cotizaciones/${e}`);
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState(state => ({ selected: state.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleCesName = (ces) => {
    let array = ces.split(" ");
    let cesName;
    for (let i = 0; i < array.length; i++) {
      cesName = array[i]++;
    }
    return cesName;
  }

  findValueWithClassForStatus = (value) => {
    if (value === 'pending') {
      return { class: 'badge_color_yellow badge', label: 'Pendiente' };
    }
    if (value === 'opened') {
      return { class: 'badge_color badge', label: 'Abierto' };
    }
    if (value === 'closed') {
      return { class: 'badge_color_red badge', label: 'Cerrado' };
    }
    return { class: 'badge_color_yellow badge', label: 'Pendiente' };
  }

  onClickDeleteCase = caseSelected => () => {
    this.setState({ isOpenModalD: true, caseSelected });
  }

  toggleModalAC = () => {
    this.props.resetContact();
    this.setState({ isOpenModalAC: false, rut: '', contactSearchit: false });
  };

  toggleModalNC = () => {
    this.setState({ isOpenModalNC: false });
  };

  onClickModalAssignCase = () => {
    this.setState({
      isOpenModalAC: true,
      hideFind: false,
      disabledIt: false,
      hideNewContact: true,
      // rut: '',
    });
  }

  isRUTValid = (rut) => {
    if (!rut) return true;
    return (new RUTJS(rut)).isValid;
  }

  onClickModalNewCase = () => {
    this.setState({
      _id: null,
      isOpenModalNC: true,
      origen: '',
      tipo: '',
      tipify: '',
      description: '',
      appointment: '',
      assign: '',
    });
  }

  onClickFilterCase = () => {
    this.setState({
      isOpenModalFilter: true,
    });
  }

  toggleFilterCase = isOk => () => {
    if (isOk) {
      this.toFilter();
    } else {
      this.setState({ isOpenModalFilter: false });
    }
  }

  cleanFilters = () => {
    this.setState({ onlyNotClosed: true, filterStatus: true });
    if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
      this.props.getAllQuotations({ onlyNotClosed: true, requiresOffers: this.state.purchaseAdvisor }, () => {
        this.setState({
          valueToFilter: {
            executive: null,
            origin: null,
            status: null,
            fromDate: null,
            toDate: null,
            inTrinidad: null,
            concessionaire: null,
            trinidadStatus: null,
          },
          search: '',
        });
      });
    } else {
      let myQuery = { onlyNotClosed: true };
      if (this.state.firstExecutive) {
        myQuery.filterStatus = true
      }
      this.props.getAllQuotationsMe(myQuery, () => {
        this.setState({
          valueToFilter: {
            executive: null,
            origin: null,
            status: null,
            fromDate: null,
            toDate: null,
            inTrinidad: null,
            concessionaire: null,
            trinidadStatus: null,
          },
          search: '',
        });
      });
    }
    this.props.history.push('/cotizaciones?page=1');
  }

  onChangeInput = key => (e) => {

    if ((key === 'origen') || (key === 'subtype') || (key === 'appointment') || key === 'executiveSelected') {
      this.setState({ [key]: e });
    } else if ((key === 'type')) {
      this.setState({ [key]: e, subtype: null });
      if (e) {
        this.props.getAllSubTypesCases({ all: true, type: e.value });
      }
    } else if (key === 'rut') {
      this.setState({ [key]: setRUTFormat(e.target.value) });
    } else {
      this.setState({ [key]: e.target.value });
    }
  }

  onChangeFilter = key => (e) => {
    const valueToFilter = { ...this.state.valueToFilter };
    if ((key === 'client')) {
      valueToFilter[key] = setRUTFormat(e.target.value);
      this.setState({ valueToFilter });
    } else {
      valueToFilter[key] = e;
      this.setState({ valueToFilter });
    }
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    const { orderBy: stateOrderBy, order: stateOrder } = this.state;

    if (stateOrderBy === property && stateOrder === 'desc') { order = 'asc'; }

    this.setState({ order, orderBy });
  };

  isSelected = (id) => {
    const { selected } = this.state;
    return selected.indexOf(id) !== -1;
  };

  onSubmitAssign = (e) => {
    e.preventDefault();
    this.setState({ disabledIt: true, contactSearchit: true });
    const { rut } = this.state;

    this.props.getContactByRut(rut.replace(/[^K0-9\s]/gi, ''), (body) => {
      if (body) {
        BasicNotification.show({
          color: 'success',
          title: 'Atención',
          message: 'Contacto encontrado.',
        });
        this.setState({ client: rut.replace(/[^K0-9\s]/gi, '') });
        this.props.history.push(`/cotizaciones/new/${this.state.client}`);
      } else {
        this.setState({
          hideFind: false,
          hideNewContact: false,
          // rut: '',
        });
      }
    });
  }

  onNewContact = () => {
    // this.props.history.push('/contactos?fromQuotations=true&newContact=true');
    this.props.history.push(`/contactos?fromQuotations=true&newContact=true&rut=${this.state.rut}`);
  }

  traducerStatus = (status) => {
    if (status === 'pending') {
      return 'Pendiente';
    }

    if (status === 'opened') {
      return 'Abierto';
    }

    if (status === 'closed') {
      return 'Cerrado';
    }
    return 'Nada';
  }

  traducerOrigin = (status) => {
    if (status === 'phone') {
      return 'Telefono';
    }

    if (status === 'web') {
      return 'Web';
    }

    if (status === 'referred') {
      return 'Referido';
    }

    if (status === 'face') {
      return 'Presencial';
    }

    if (status === 'trinidad') {
      return 'Trinidad';
    }

    if (status === 'spider') {
      return 'Spider';
    }
    return '';
  }

  traducerSituation = (status) => {
    if (status === 'dependent') {
      return 'Dependiente';
    }

    if (status === 'independent') {
      return 'Independiente';
    }

    return status;
  }

  onClickDeleteContacto = contact => () => {
    this.setState({ isOpenModalD: true, contact });
  }

  toggleDeleteContacto = isOk => () => {
    if (isOk) {
      this.onDelete();
    } else {
      this.setState({ isOpenModalD: false });
    }
  }

  onDelete = () => {
    const { caseSelected } = this.state;
    this.props.deleteCase(caseSelected._id, () => {
      this.props.getAllCases({ onlyNotClosed: true });
      this.setState({ isOpenModalD: false });
    });
  }

  toFilter = () => {
    const { valueToFilter } = this.state;
    const dataToFilter = {};

    if (valueToFilter.executive != null) {
      dataToFilter.executive = valueToFilter.executive.value;
    }

    if (valueToFilter.concessionaire != null) {
      dataToFilter.concessionaire = valueToFilter.concessionaire.value;
    }

    if (valueToFilter.trinidadStatus != null) {
      dataToFilter.trinidadStatus = valueToFilter.trinidadStatus.value;
    }

    if (valueToFilter.origin != null) {
      dataToFilter.origin = valueToFilter.origin.value;
    }

    if (valueToFilter.status != null) {
      dataToFilter.status = valueToFilter.status.value;
    }

    if (valueToFilter.fromDate != null) {
      dataToFilter.fromDate = moment(valueToFilter.fromDate).format('DD-MM-YYYY');
    }

    if (valueToFilter.toDate != null) {
      dataToFilter.toDate = moment(valueToFilter.toDate).format('DD-MM-YYYY');
    }

    if (valueToFilter.inTrinidad != null) {
      dataToFilter.inTrinidad = valueToFilter.inTrinidad.value;
    }

    let query = QueryString.parse(this.props.location.search);
    if (dataToFilter) {
      query = {};
    }

    if (this.state.firstExecutive) {
      dataToFilter.filterStatus = false;
    }

    dataToFilter.onlyNotClosed = false;
    dataToFilter.page = 1;

    Object.assign(query, dataToFilter);

    this.setState({ filterStatus: false, onlyNotClosed: false });

    if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
      this.props.getAllQuotations({ ...query, requiresOffers: this.state.purchaseAdvisor }, () => {
        this.props.history.push(`/cotizaciones?${QueryString.stringify(query)}`);
        this.setState({ isOpenModalFilter: false });
      });
    } else {
      this.props.getAllQuotationsMe({ ...query }, () => {
        this.props.history.push(`/cotizaciones?${QueryString.stringify(query)}`);
        this.setState({ isOpenModalFilter: false });
      });
    }
  }

  onSubmitSearch = (e) => {
    e.preventDefault();
    const { search } = this.state;
    let query = QueryString.parse(this.props.location.search);

    this.setState({ onlyNotClosed: false, filterStatus: false });

    if (search === null) {
      query = {};
    }

    Object.assign(query, { search });
    // const isAdmin = isUserAllowed('admin') || isUserAllowed('manager');

    if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
      this.props.getAllQuotations({ ...query, requiresOffers: this.state.purchaseAdvisor }, () => {
        this.props.history.push(`/cotizaciones?${QueryString.stringify(query)}`);
      });
    } else {
      this.props.getAllQuotationsMe(query, () => {
        this.props.history.push(`/cotizaciones?${QueryString.stringify(query)}`);
      });
    }
  }

  onChangeSearch = (e) => {
    this.setState({ search: e.target.value });
  }

  onChangePage = (page) => {
    const { onlyNotClosed, filterStatus } = this.state
    this.setState({ page });
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/cotizaciones?${QueryString.stringify({ ...query, page: page + 1 })}`);
    if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
      this.props.getAllQuotations({ onlyNotClosed, requiresOffers: this.state.purchaseAdvisor, ...query, page: page + 1 });
    } else {
      let myQuery = { onlyNotClosed, ...query, page: page + 1 };
      if (this.state.firstExecutive) {
        myQuery.filterStatus = filterStatus
      }
      this.props.getAllQuotationsMe(myQuery);
    }
  }

  onChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
    const { onlyNotClosed, filterStatus } = this.state
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/cotizaciones?${QueryString.stringify({ ...query, limit: rowsPerPage })}`);
    if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
      this.props.getAllQuotations({ onlyNotClosed, requiresOffers: this.state.purchaseAdvisor, ...query, limit: rowsPerPage });
    } else {
      let myQuery = { onlyNotClosed, ...query, limit: rowsPerPage };
      if (this.state.firstExecutive) {
        myQuery.filterStatus = filterStatus
      }
      this.props.getAllQuotationsMe(myQuery);
    }
  }

  onClickRow = id => () => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    this.setState({ selected: newSelected });
  }

  onClickReasingQuotation = () => {
    this.setState({
      isOpenModalReasing: true,
    });
  }

  selectQuotationsToReasign = e => () => {
    const { reasignQuotations } = this.state;

    if (find(reasignQuotations, aCase => aCase.id === e.id)) {
      remove(reasignQuotations, aCase => aCase.id === e.id);
    } else {
      reasignQuotations.push(e);
    }
    if (reasignQuotations.length === 0) {
      this.setState({ reasign: true });
    } else {
      this.setState({ reasignQuotations, reasign: false, checked: filter(reasignQuotations, (e) => e.isSharpspringInformed) });
    }
  }

  onSelectAllClick = (checked) => {
    if (checked) {
      const { allCases } = this.props;

      let { reasignQuotations } = this.state;

      if (reasignQuotations.length === 0) {
        allCases.map((allCase) => {
          reasignQuotations.push({ id: allCase._id, code: allCase.code, isSharpspringInformed: false });
        });
        this.setState({ reasign: true });
      } else {
        reasignQuotations = [];
        allCases.map((allCase) => {
          reasignQuotations.push({ id: allCase._id, code: allCase.code, isSharpspringInformed: false });
          // }
        });
        this.setState({ reasignQuotations, reasign: false, checked: filter(reasignQuotations, (e) => e.isSharpspringInformed) });
      }

      this.setState({ selected: allCases.map(allCase => allCase._id) });
      return;
    }
    this.setState({ selected: [], reasignQuotations: [], checked: [] });
  }

  toggleReasign = isOk => () => {
    if (isOk) {
      this.setState({ reasign: true });
      this.onSubmitTransferQuotations();
    } else {
      this.setState({ isOpenModalReasing: false, executiveSelected: null });
    }
  }

  onSubmitTransferQuotations = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const { executiveSelected, reasignQuotations, filterStatus, onlyNotClosed } = this.state;

    const quotations = reasignQuotations.map(reasignQuotation => ({
      id: reasignQuotation.id,
      // comprueba que se haya seleccionado como shapspring, y que el ejecutivo tenga shapspring 
      isSharpspringInformed: false
    }));

    if (executiveSelected === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un ejecutivo destinatario.',
      });

      return;
    }

    await this.props.updateQuotationMany({ action: 'assignExcecutive', executive: executiveSelected.value, quotations }, () => {
      this.setState({ isOpenModalReasing: false });

      if (this.state.justAdminOrManager || this.state.purchaseAdvisor) {
        this.props.getAllQuotations({ onlyNotClosed, requiresOffers: this.state.purchaseAdvisor });
      } else {
        let myQuery = { onlyNotClosed };
        if (this.state.firstExecutive) {
          myQuery.filterStatus = filterStatus
        }
        this.props.getAllQuotationsMe(myQuery);
      }
    });
    this.setState({ selected: [], reasignCases: [], reasignQuotations: [], isOpenModalReasing: false, executiveSelected: null });
  }

  setPage = (page) => {
    this.setState({ page });
  }

  evaluationStatusFormatter = (status) => {
    if (`${status}` === 'EN EVALUACION DE ANALISTA') {
      return 'En Evaluación de Analista';
    } else {
      return status;
    }
  }

  handleStartDate = (date) => {
    this.setState({ startDate: date, dateError: undefined });
  }

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  }

  handleExport = () => {
    this.validateToday() ? this.setState({ dateError: 'El inicio no puede ser hoy' }) :
      this.props.getExcelQuotations(moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'));
  }

  validateToday = () => moment(this.state.startDate).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY')

  statusShower = (trinidad, web) => (trinidad ? trinidad : (web ? `${upperCase(web.status)}` : ''));

  emptySearch = () => {
    const fields = Object.keys(QueryString.parse(this.props.location.search));
    const page = some(fields, (e) => e === 'page');
    return ((page && fields.length === 1) || fields.length === 0);
  }

  render() {
    const {
      // activeTab,
      rowsPerPage, page,
      // order, orderBy,
      selected,
    } = this.state;
    const {
      allQuotations,
      loadingQuoations,
      total,
      loadingReasing,
    } = this.props;

    const data = allQuotations
      // .sort(getSorting(order, orderBy))
      // .slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage)
      .map(d => ({
        // const isSelected = this.isSelected(d._id);
        // const statusTranslate = this.findValueWithClassForStatus(d.status);
        id: d._id,
        code: d.code,
        date: d.createdAt,
        isSharpspringInformed: false,
        cells: (
          <Fragment>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{d.code || ''}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{originTraducer(d.origin) || ''}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{`${d.dealerName ? d.dealerName : ''}` || ''}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left"><span className={this.findValueWithClassForStatus(d.status).class}>{this.findValueWithClassForStatus(d.status).label || ''}</span></TableCell>
            {/* <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{`${d.evaluationState ? this.evaluationStatusFormatter(d.evaluationState) : ''}` || ''}</TableCell> */}
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{this.statusShower(d.trinidadStatus, d.evaluationStatus)}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{d.client && (`${d.client.companyName || ''} ${d.client.names || ''} ${d.client.paternalSurname || ''}`)}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px', width: '10%' }} align="left">{d.client && (`${setRUTFormat(d.client.rut) || ''}`)}</TableCell>
            <TableCell className="material-table__cell" onClick={this.onClickQuotationView(d._id)} style={{ borderBottom: '0px' }} align="left">{moment(d.createdAt).format('DD/MM/YYYY,HH:mm:ss')}</TableCell>
            {(this.state.justAdminOrManager || this.state.secondContact) &&
              <TableCell className="material-table__cell"
                onClick={this.onClickQuotationView(d._id)}
                style={{ borderBottom: '0px' }} align="left">
                {`${d?.offers?.offersStatus || 'Sin ofertas'}`}
              </TableCell>
            }
            {(this.state.justAdminOrManager || this.state.secondContact) &&
              <TableCell className="material-table__cell"
                onClick={this.onClickQuotationView(d._id)}
                style={{ borderBottom: '0px' }} align="left">
                {`${d?.offers?.offersCount || 0}`}
              </TableCell>
            }
            {this.state.justAdminOrManager &&
              <TableCell className="material-table__cell"
                onClick={this.onClickQuotationView(d._id)}
                style={{ borderBottom: '0px' }}
                align="left">
                {d.executive ? `${d.executive.firstName} ${d.executive.lastName}` : '-'}
              </TableCell>
            }
            {(this.state.justAdminOrManager || this.state.purchaseAdvisor) &&
              <TableCell className="material-table__cell"
                onClick={this.onClickQuotationView(d._id)}
                style={{ borderBottom: '0px' }} align="left">
                {`${d.newRequiresOffers ?
                  (some(d.offeringsOrder ? d.offeringsOrder : [], (e) => e.advisor === getUserId()) ? 'No' : 'Sí')
                  : 'No'}`}
              </TableCell>
            }
          </Fragment>
        ),
      }));

    return (
      <div>
        <ModalAC
          onSubmitAssign={this.onSubmitAssign}
          onChangeInput={this.onChangeInput}
          onNewContact={this.onNewContact}
          isRUTValid={this.isRUTValid}
          toggle={this.toggleModalAC}
          hideNewContact={this.state.hideNewContact}
          contactSearchit={this.state.contactSearchit}
          loadingContact={this.props.loadingContact}
          disabledIt={this.state.disabledIt}
          isOpen={this.state.isOpenModalAC}
          hideFind={this.state.hideFind}
          contact={this.props.contact}
          value={this.state}
        />
        <FilterModal
          isOpen={this.state.isOpenModalFilter}
          title={'Filtro Cotizaciones'}
          toggle={this.toggleFilterCase}
          onChangeFilter={this.onChangeFilter}
          usersFilters={this.state.usersFilters}
          concessionaires={this.state.concessionaires}
          isAdminP={isUserAllowed('admin')}
          isRUTValid={this.isRUTValid}
          valueToFilter={this.state.valueToFilter}
          cleanFilters={this.cleanFilters}
        />
        <ModalReasingSharp
          title="Reasignación de casos"
          color="warning"
          message="¿Esta seguro que desea borrar este registro?"
          isOpen={this.state.isOpenModalReasing}
          toggle={this.toggleReasign}
          onChange={this.onChangeInput}
          values={this.state.reasignQuotations}
          onwer={this.state.reasignQuotationsOnwer}
          executives={this.state.executives}
          executiveSelected={this.state.executiveSelected}
          loadingReasing={loadingReasing}
          checked={this.state.checked}
        />
        <Card className="pb-3">
          <CardBody className="card_body_flex" style={{ padding: '5px 10px' }}>
            <Col md="8" className='crm-col-container'>
              <form className='crm-form-container' onSubmit={this.onSubmitSearch}>
                <div className='crm-search-input-container'>
                  <Icon path={mdiMagnify} size={1} />
                  <input
                    onChange={this.onChangeSearch}
                    value={this.state.search}
                    placeholder="Nombre o RUT cliente"
                  />
                  <button
                    type="button"
                    onClick={this.cleanFilters}
                    disabled={!this.state.search}
                  >
                    <Icon path={mdiClose} />
                  </button>
                </div>
                <button
                  type="button"
                  className='crm-actions-btn'
                  onClick={this.onClickFilterCase}
                >
                  <Icon path={mdiFilterOutline} />
                </button>
                <button
                  type="button"
                  className='crm-actions-btn'
                  onClick={this.cleanFilters}
                  hidden={this.emptySearch()}
                >
                  <Icon path={mdiFilterRemoveOutline} />
                </button>
              </form>
            </Col>

            {!isUserAllowed(ROLES.auditor) &&
              <Col md="4" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Col xs="auto" sm="auto" md="auto">
                  <button type="button" hidden={!this.state.reasignQuotations.length} onClick={this.onClickReasingQuotation} className="crm-white-btn">
                    Reasignar
                  </button>
                </Col>
              </Col>}

            <Col style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Col xs="auto" sm="auto" md="auto" style={{ marginBottom: this.state.dateError ? '0px' : '20px', paddingLeft: '0px', paddingRight: '0px' }}>
                <Label className='export-label'>Desde</Label>
                <DatePicker
                  // selectsRange={true}
                  className='export-picker'
                  maxDate={new Date()}
                  selected={this.state.startDate}
                  onChange={(date) => this.handleStartDate(date)}
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  locale={'es'}
                  dateFormat="P"
                />
                {this.state.dateError && <p className='export-error'>{this.state.dateError}</p>}
              </Col>
              <Col xs="auto" sm="auto" md="auto" style={{ marginBottom: '20px', paddingLeft: '0px', paddingRight: '0px' }}>
                <Label className='export-label'>Hasta</Label>
                <DatePicker
                  className='export-picker'
                  selected={this.state.endDate}
                  onChange={(date) => this.handleEndDate(date)}
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  minDate={this.state.startDate}
                  maxDate={new Date()}
                  locale={'es'}
                  dateFormat="P"
                />
              </Col>
              <Col xs="auto" sm="auto" md="auto">
                <button
                  type="button"
                  style={{ margin: '6px 0px' }}
                  className={this.validateToday() ? 'asignar2 new_contact_button export-btn-disabled' : "asignar2 new_contact_button"}
                  onClick={this.handleExport}
                >Exportar</button>
              </Col>
            </Col>
          </CardBody>
        </Card>
        {
          loadingQuoations && (
            <Skeleton count={rowsPerPage + 1} height={40} />
          )
        }

        {
          !loadingQuoations && (
            <MatTable
              onSelectAllClick={this.onSelectAllClick}
              onChangePage={this.onChangePage}
              cargando={loadingQuoations}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
              onClickRow={this.onClickRow}
              onClick={this.onClickQuotationView}
              onChange={this.selectQuotationsToReasign}
              selected={selected}
              headers={this.state.headers}
              data={data}
              page={page}
              rowsPerPage={rowsPerPage}
              total={total}
              justAdminOrManager={this.state.justAdminOrManager}
              checkbox
            />
          )
        }
      </div >
    );
  }
}


const mapStateToProps = ({ contacts, users, quotations }) => ({
  users: users.collection,
  contact: contacts.contact,
  loadingContact: contacts.loadingContact,
  contacts: contacts.collection,
  total: quotations.countQuotations,
  limit: quotations.limitQuotations,
  loadingQuoations: quotations.loadingQuoations,
  quotations: quotations.quotationsInfo,
  allQuotations: quotations.allQuotations,
  loadingReasing: quotations.loadingReasing,
  concessionaires: quotations.ces
});


const mapDispatchToProps = {
  updateQuotationMany,
  getExcelQuotations,
  getAllQuotationsMe,
  getConcessionaires,
  getAllQuotations,
  getContactByRut,
  resetContact,
  getContacts,
  getUsers,
};
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(DefaultTabsBorderedBottom);
